import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ContactCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[400px] md:min-h-[560px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20locksmith%20workshop%20workbench%20with%20sleek%20silver%20titanium%20keys%20and%20contemporary%20cylinder%20locks%20arranged%20on%20a%20dark%20charcoal%20surface%2C%20cool%20dramatic%20overhead%20lighting%20creating%20clean%20silver%20reflections%2C%20state-of-the-art%20digital%20key%20cutting%20machine%20in%20soft%20focus%20background%2C%20contemporary%20professional%20workshop%20atmosphere%2C%20cool%20silver%20and%20gunmetal%20tones%20contrasting%20with%20dark%20background%2C%20editorial%20photography%20with%20cinematic%20depth%20of%20field%2C%20premium%20modern%20industrial%20aesthetic%2C%20precision%20tools%20and%20laser-cut%20keys%20glinting%20under%20focused%20cool%20light&width=1600&height=800&seq=cta-modern-keys-v3&orientation=landscape"
        alt="Contact Clefs de Lys SA for modern key and cylinder services"
        title="Contact Clefs de Lys SA keys and cylinders"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
              {t("cta.heading")}
            </h2>
            <p className="text-sm md:text-base text-background-50/75 mt-4 md:mt-6 max-w-md leading-relaxed">
              {t("cta.description")}
            </p>

            <div className="mt-8 md:mt-10 space-y-5">
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20 flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-primary-400 text-sm"></i>
                </span>
                <div>
                  <p className="text-xs text-background-50/40 uppercase tracking-wide mb-0.5">{t("cta.addressLabel")}</p>
                  <p className="text-sm text-background-50/80 leading-relaxed">
                    Rue Alexandre Cailler 6<br />
                    1636 Broc<br />
                    Switzerland
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20 flex-shrink-0">
                  <i className="ri-phone-line text-primary-400 text-sm"></i>
                </span>
                <div>
                  <p className="text-xs text-background-50/40 uppercase tracking-wide mb-0.5">{t("cta.phoneLabel")}</p>
                  <a
                    href="tel:+41211234567"
                    className="text-sm text-background-50/80 hover:text-primary-400 transition-colors"
                  >
                    +41 26 919 53 60
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20 flex-shrink-0">
                  <i className="ri-mail-line text-primary-400 text-sm"></i>
                </span>
                <div>
                  <p className="text-xs text-background-50/40 uppercase tracking-wide mb-0.5">{t("cta.emailLabel")}</p>
                  <a
                    href="mailto:service@clefsdelys.ch"
                    className="text-sm text-background-50/80 hover:text-primary-400 transition-colors"
                  >
                    service@clefsdelys.ch
                  </a>
                </div>
              </div>
            </div>

            <Link
              to="/contact"
              className="mt-8 md:mt-10 inline-flex items-center gap-3 px-7 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm md:text-base cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              {t("cta.button")}
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-50/20">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </span>
            </Link>
          </div>

          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-br from-primary-500/15 via-transparent to-accent-500/10 rounded-2xl blur-sm"></div>
            <div className="relative rounded-2xl overflow-hidden border border-background-50/10">
              <iframe
                src="https://maps.google.com/maps?q=Rue%20Alexandre%20Cailler%206%2C%201636%20Broc%2C%20Switzerland&t=m&z=15&output=embed"
                title="Clefs de Lys SA location - Rue Alexandre Cailler 6, 1636 Broc"
                className="w-full h-[280px] md:h-[340px]"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}